import React, { useState, forwardRef, useRef } from "react";
import TimeLineSteps, {
  GetStepCount,
  AccordionWrapperStep
} from "./TimeLineSteps";
import {
  HorizontalLine,
  AccordionRows,
  HowItWorksStepWrapper,
  FocusDiv
} from "./styles";
import { CapsuleButton } from "../Commons/commonComponents";
import { RelativeDiv } from "../../Epics/Grants/Pages/HowItWorks/styles";

export default ({
  howItWorksDetails,
  stepCount,
  handleScrollToTOp,
  myCustomRef
}) => {
  const [expand, setexpand] = useState();
  const triggerScrollToTOp = (expand,subTitle) => {
    setexpand(expand);
    handleScrollToTOp(stepCount, expand,subTitle);
  };
  const subTitle = `Step${stepCount} ${howItWorksDetails[
    `field_step_${stepCount}_title`
    ]}`
  return (
    <RelativeDiv>
      <AccordionRows>
        <GetStepCount stepCount={stepCount} />
        <HowItWorksStepWrapper>
          <AccordionWrapperStep
            expand={expand}
            stepCount={stepCount}
            howItWorksDetails={howItWorksDetails}
            triggerScrollToTOp={triggerScrollToTOp}
            ref={myCustomRef}
          />

          {expand ? (
            <>
              <HorizontalLine />
              <TimeLineSteps
                stepCount={stepCount}
                step="1"
                howItWorksDetails={howItWorksDetails}
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="2"
                howItWorksDetails={howItWorksDetails}
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="3"
                howItWorksDetails={howItWorksDetails}
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="4"
                howItWorksDetails={howItWorksDetails}
              />
              <CapsuleButton
                text="Show Less"
                whiteBackground={true}
                disabled={false}
                id="btnShowData"
                height="30px"
                fontSize="16px"
                enableLeft="50px"
                iconType="arrowUp"
                top="30px"
                onClick={() => {
                  triggerScrollToTOp(false,subTitle);
                }}
              />
            </>
          ) : (
            <CapsuleButton
              text="Show More"
              whiteBackground={true}
              disabled={false}
              data-test="btnShowMoreHowItWorks"
              id={`${stepCount}btnShowMoreHowItWorks`}
              height="30px"
              fontSize="16px"
              enableLeft="50px"
              top="30px"
              iconType="arrowDown"
              onClick={() => {
                triggerScrollToTOp(true,subTitle);
              }}
            />
          )}

          <FocusDiv
            data-test="grantStepWebAccordianFocusDiv"
            className={`focusDiv ${
                expand 
                ? "focusCollapsed"
                : "focusExpanded"
            }`}
            id={stepCount}
            onClick={() => {
                !expand &&
                triggerScrollToTOp(true,subTitle);
            }}
          />
        </HowItWorksStepWrapper>
      </AccordionRows>
    </RelativeDiv>
  );
};
